import { render } from "./CopifyJob.vue?vue&type=template&id=9953667e"
import script from "./CopifyJob.vue?vue&type=script&lang=js"
export * from "./CopifyJob.vue?vue&type=script&lang=js"

import "./CopifyJob.vue?vue&type=style&index=0&id=9953667e&lang=less"

import exportComponent from "/codebuild/output/src3271881597/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__